export const apiUrl = process.env.VUE_APP_DOMAIN;
export const appName = process.env.VUE_APP_NAME;
export const quickSightDashboardUrl = process.env.VUE_APP_QUICKSIGHT_DASHBOARD_URL;
export const versionSystem = '1.5.0';
